/**
 * Delay calling of callback function on set time
 * @param {Function} callback - The function to be run
 * @param {Number} time - Delay time in milliseconds
 *
 * @returns {Function}
 */
export function debounce(callback, time) {
  let timer = null
  return function(...args) {
    const onComplete = () => {
      callback.apply(this, args)
      timer = null
    }

    if (timer) {
      clearTimeout(timer)
    }

    timer = setTimeout(onComplete, time)
  }
}
